import {Dropdown, Layout, Menu, notification} from 'antd';
import {UserOutlined} from '@ant-design/icons';
import {useEffect, useRef, useState} from "react";
import {Route, Routes, useLocation, useNavigate} from "react-router-dom";
import {RouterMethod} from "../Type/Permission/PermissionChannel";
import TreedPermissionChannel from "../Type/Permission/TreedPermissionChannel";
import {IsTokenValid, UseFirstMount} from "@yw/ibmp-utils";
import NotFound from "./Components/NotFound";
import usePublicPage from "../Hooks/usePublicPage";
import "../index.css";
import styled from "styled-components";
import Logo from "../Assets/Image/0abd0f5aa9cdc89d4e2d.png";
import Home from "../Page/Home";
import ExternalContainer from "../Page/ExternalContainer";
import isNullOrUndefined from "../Utlis/isNullOrUndefined";

const {Header, Sider, Content} = Layout;


const {SubMenu} = Menu;


function BasicLayout() {
    const isPublic = usePublicPage();
    let location = useLocation();
    const [data, setData] = useState<Array<TreedPermissionChannel>>([]);
    const [defaultSelected, setDefaultSelected] = useState<string>("");
    const routersRef = useRef<Array<TreedPermissionChannel>>([]);
    // 这里存放的是flatten之后的结果
    const permissions = useRef<Array<TreedPermissionChannel>>([]);
    const [switchingPage, setSwitchingPage] = useState<boolean>(false);
    let nav = useNavigate();

    useEffect(() => {
        if (!isPublic.isLogin() && !IsTokenValid()) return;
        if (!isPublic.isLogin() && routersRef.current.length === 0) {
            try {
                routersRef.current = JSON.parse(localStorage.allowedRouters);
                permissions.current = JSON.parse(localStorage.permissions);
                setData(routersRef.current);
                navToFirstAvailablePage(routersRef.current);
            } catch (e) {
                // 如果无法正常解析localStorage, 则表示登录状态有异常, 跳转登录页面
                history.pushState(null, "", "/usercenter/login/");
            }
        }
    }, [location]);

    // 处理不被允许的路由
    useEffect(() => {
        setSwitchingPage(true);
        if (data.length !== 0) {
            let channelPath = `${location.pathname}${location.hash !== "" && location.hash !== "#/" ? location.hash?.split("#")[1] : ""}`;
            if (isAllowed(channelPath) || isPublic.isPublicPage()) {
                setSwitchingPage(false);
                return;
            }
            setSwitchingPage(false);
            history.pushState(null, "", "/404");
        }
    }, [location, data])

    useEffect(() => {
        setDefaultSelected(location.pathname + location.hash);
        if (UseFirstMount.check('root')) {
            //初始化通用页面
            localStorage.pages = JSON.stringify({
                "loginUrl:": "/usercenter/login",
                "p404": "/404",
                "p500": "/500",
            })
        }
    });

    function navToFirstAvailablePage(menus: Array<TreedPermissionChannel>) {
        // 尝试跳转到第一个可用页面
        if (isPublic.isHome) {
            if (routersRef.current.length > 0) {
                const firstEntry = routersRef.current[0];
                if (firstEntry.children.length > 0) {
                    const firstPage = firstEntry.children[0];
                    // 如果第一个页面是打开新窗口的链接类型, 则不主动跳转
                    if (firstPage.routerMethod === RouterMethod.Link && !isExternalApp(firstPage.channelPath)) {
                        return;
                    }
                    handleMenuClick(firstPage.channelPath, firstPage.routerMethod, firstPage.link);
                } else if (isConcretePage(firstEntry.channelPath)) {
                    // 如果第一个页面是打开新窗口的链接类型, 则不主动跳转
                    if (firstEntry.routerMethod === RouterMethod.Link && !isExternalApp(firstEntry.channelPath)) {
                        return;
                    }
                    handleMenuClick(firstEntry.channelPath, firstEntry.routerMethod, firstEntry.link);
                }
            }
        }
    }


    function isExternalApp(channelPath: string) {
        if (!isConcretePage(channelPath)) {
            return false;
        }
        let splited = channelPath.split("/");
        let application = splited[1];

        return application === "external";
    }

    function handleMenuClick(channelPath: string, routerMethod: RouterMethod, link?: string) {
        const splited = channelPath.split("/");
        let application = splited[1];
        splited.splice(1, 1);

        if (routerMethod === RouterMethod.Link) {
            if (link) {
                try {
                    let url = new URL(link);
                    // 保留external作为特殊应用, 在此应用下的Link类型的路由, 都将由iframe打开
                    if (application === "external") {
                        nav(`/${application}${splited.join("/")}`, {
                            state: {
                                link: link
                            }
                        });
                    } else {
                        window.open(url, "_blank");
                    }
                } catch (e) {
                    notification["info"]({
                        message: "不是合法的URL",
                        description: "请检查链接配置, 正确的链接应配置如https://abc.def.com"
                    });
                }
                return;
            }
            notification["info"]({
                message: "未配置目标链接, 请检查配置"
            });
            return;
        }

        nav(`/${application}${routerMethod === RouterMethod.Browser ? "" : "#"}${splited.join("/")}`);
    }


    function isPathMatch(p1: string, p2: string) {
        if (isNullOrUndefined(p1) || isNullOrUndefined(p2)) {
            return false;
        }
        //去除？参数
        p2 = p2.replace(/\?.*/g, '')
        let arr1 = p1.toLowerCase().split("/").filter(item => item !== "");
        let arr2 = p2.toLowerCase().split("/").filter(item => item !== "");
        //只取前三级
        arr2 = arr2.length > 3 ? [arr2[0], arr2[1], arr2[2]] : arr2;
        if (arr1.length !== arr2.length) {
            return false;
        }
        for (let i = 0; i < arr1.length; i++) {
            if (arr1[i] !== arr2[i]) {
                return false;
            }
        }
        return true;
    }

    function isAllowed(channelPath: string) {
        let res = permissions.current.find(item => isPathMatch(item.channelPath, channelPath));

        if (res) {
            return res.policy.allowPath.length > 0
        }
        return false;
    }

    // 根据channelPath判断一个路径是否对应一个页面
    function isConcretePage(channelPath: string) {
        if (!isNullOrUndefined(channelPath)) {
            let split = channelPath.split("/").filter(item => item !== "");
            // 三级channelPath在逻辑上对应具体的页面
            return split.length === 3;
        }
        return false;
    }

    function handleLogOut() {
        routersRef.current = [];
        permissions.current = [];
        setData([]);
        localStorage.clear();
        history.pushState(null, "", `/usercenter/login`);
    }

    function handleUpdatePassword() {
        history.pushState(null, "", "/usercenter/updatePassword");
    }

    function hideLayout() {
        return window.location.href
            .toLowerCase()
            .includes("rootHideLayout=true".toLowerCase());
    }

    const menu = (
        <Menu>
            <Menu.Item key="1" onClick={handleUpdatePassword}>
                修改密码
            </Menu.Item>
            <Menu.Item key="2" onClick={handleLogOut}>
                退出登录
            </Menu.Item>
        </Menu>
    );

    return (
        <Layout>
            {
                !isPublic.isLogin() && !hideLayout() &&
                <Header className="global-header" style={{height: 30, lineHeight: "30px", padding: "0 24px"}}>
                    <LeftPartSC>
                        {/*<img src={Logo} alt=""/>*/}
                        {/*{`${location.pathname}${location.hash !== "" && location.hash !== "#/" ? location.hash?.split("#")[1] : ""}`?.toLowerCase()}*/}
                    </LeftPartSC>
                    <RightPartSC>
                        <Dropdown overlay={menu}>
                            <UserOutlined style={{fontSize: 23, lineHeight: "35px"}}/>
                        </Dropdown>
                    </RightPartSC>
                </Header>
            }
            <Layout>
                {
                    !isPublic.isLogin() && !hideLayout() &&
                    <Sider trigger={null} collapsedWidth={50} breakpoint="md" collapsible style={{height: "calc(100vh - 30px)", overflow: "auto"}}>
                        <Menu theme="dark" mode="inline"
                              selectedKeys={[`${location.pathname}${location.hash !== "" && location.hash !== "#/" ? location.hash?.split("#")[1] : ""}`.toLowerCase()]}>
                            {
                                data?.filter(item => item.isMenu)?.map((item, index) => {
                                    return (
                                        item.children?.length > 1 ?
                                            <SubMenu title={item.viewName} key={item.viewChannelPath}>
                                                {
                                                    item.children?.filter(item => item.isMenu)?.map(inner => {
                                                        return (
                                                            <Menu.Item onClick={() => handleMenuClick(inner.channelPath, inner.routerMethod, inner.link)} key={inner.channelPath.toLowerCase()}>
                                                                {
                                                                    inner.viewName
                                                                }
                                                            </Menu.Item>
                                                        )
                                                    })
                                                }
                                            </SubMenu> :
                                            //  如果一个菜单项children数量小于1, 但是其本身就是具体的页面, 则直接进行展示
                                            isConcretePage(item.channelPath) ?
                                                <Menu.Item onClick={() => handleMenuClick(item.channelPath, item.routerMethod, item.link)}
                                                           key={item.channelPath.toLowerCase()}>
                                                    {
                                                        item.viewName
                                                    }
                                                </Menu.Item>
                                                :
                                                item.children?.map(inner => {
                                                    return (
                                                        <Menu.Item onClick={() => handleMenuClick(inner.channelPath, inner.routerMethod, inner.link)} key={inner.channelPath.toLowerCase()}>
                                                            {
                                                                inner.viewName
                                                            }
                                                        </Menu.Item>
                                                    )
                                                })
                                    )
                                })
                            }
                        </Menu>
                    </Sider>
                }
                <Layout>
                    <Routes>
                        <Route path="/" element={<Home/>}/>
                        <Route path="/404" element={<NotFound/>}/>
                        <Route path="/external/*" element={<ExternalContainer/>}/>
                        <Route path="*" element={<Content>
                            <div style={{padding: hideLayout() ? 0 : 10}}>
                                <div id="usercenter" className={"appcontainer"}></div>
                                <div id="publiccommunity"></div>
                                <div id="pcdataadjust"></div>
                                <div id="vrhouseprocessadmin"></div>
                                <div id="modelprocess"></div>
                            </div>
                        </Content>}/>
                    </Routes>
                </Layout>
            </Layout>
        </Layout>
    );
}

const LeftPartSC = styled("div")`
    img {
        object-fit: contain;
        height: 100%;
    }

    height: 100%;
`;

const RightPartSC = styled("div")`
    color: white;
    height: 100%;
`;
export default BasicLayout;
